<template>
  <Page class="quiz-final">

    <container class="quiz-final__inner">

      <Header class="quiz-final__header" size="sm"></Header>

      <div class="quiz-final__split">
        <div class="quiz-final__main">
          <div class="quiz-final__count">{{ count }}</div>
          <Bullets class="quiz-final__bullets" :bullets="bullets" hint></Bullets>
          <h3 class="title quiz-final__title" v-html="results.title"></h3>
          <p class="text quiz-final__text" v-html="results.text" v-if="results.text"></p>
          <Likes class="quiz-final__likes"></Likes>
          <Button class="quiz-final__restart" @click="restart">Пройти заново</Button>
        </div>

        <div class="quiz-final__aside" v-if="!submited">
          <Form @submit="onSubmited" class="quiz-final__form">
            <template v-slot:text>
              <div class="quiz-final__form-text">
                <p class="text">
                  Wi-Fi 6&nbsp;решает ключевые задачи связи в&nbsp;ресторанах, торговых центрах, образовательных учреждениях, промышленных и&nbsp;транспортных объектах.
                </p>
                <p class="text" style="font-weight: 600">
                  Вы&nbsp;можете заказать консультацию для своего бизнеса или бесплатный тест оборудования Wi-Fi 6&nbsp;от&nbsp;Huawei, заполнив форму:
                </p>
                <p class="subtext">
                  * Услуга предоставляется только юридическим лицам
                </p>
              </div>
            </template>
          </Form>
        </div>
      </div>
    </container>

    <Alert :open="modal" @close="modal = false">
      <div style="text-align: center">
        <div class="title">
          Спасибо
        </div>
        <p class="text" style="margin-bottom: 20px;">
          Наши менеджеры скоро свяжутся с&nbsp;вами.
        </p>
        <Button @click="modal = false">Отлично</Button>
      </div>
    </Alert>

    <Footer class="quiz-final__footer"></Footer>
  </Page>
</template>

<script>
  import Footer from '@/components/Footer.vue'
  import Form from '@/components/Form.vue'
  import Bullets from '@/components/Quiz/Bullets.vue'
  import Likes from '@/components/Likes.vue'
  import Header from '@/components/Header.vue'
  import Alert from '@/components/Alert.vue'

  export default {
    components: { Bullets, Likes, Form, Footer, Header, Alert },
    data () {
      return {
        modal: false,
        submited: false,
      }
    },
    computed: {
      count () {
        const total = this.bullets.length
        const correct = this.bullets.filter(({ correct }) => !!correct).length
        return `${correct} из ${total}`
      },
      bullets () {
        return this.$store.getters.bullets
      },
      results () {
        return this.$store.state.results
      }
    },
    methods: {
      onSubmited () {
        this.submited = true
        this.modal = true
        this.$metrics.pushEvent(this.$metrics.events.FORM_SENT)
      },
      restart () {
        this.$store.dispatch('reset')
        this.$metrics.pushEvent(this.$metrics.events.CLICK_RESTART_QUIZ)
      }
    }
  }
</script>

<style lang="scss">
  .quiz-final__inner {

  }

  .quiz-final__header {
    transition: 1s opacity, 1s transform;

    @include more(scale) {
      margin-top: 30px;
    }
    @include mq(scale) {
      margin-bottom: 70px;
    }
    @include screen-height(low) {
      margin-bottom: 70px;
    }
    @include screen-height(high) {
      margin-bottom: 150px;
    }
    @include less(tablet) {
      margin-top: 15px;
      margin-bottom: 60px;
    }
    @include screen-height(mobile-low) {
      margin-bottom: 40px;
    }
  }

  .quiz-final__header .header__special-label {
    transition: 0.7s opacity, 0.7s transform;
  }

  .quiz-final__split {
    @include more(scale) {
      display: flex;
      & > * {
        flex: 0 0 auto;
        width: 50%;
      }
    }
    @include mq(scale) {
      & > * {
        &:first-child {
          padding-right: 10rem;
        }
        &:last-child {
          padding-left: 10rem;
        }
      }
    }
  }

  .quiz-final__form {
    @include mq(tablet) {
      max-width: 480px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .quiz-final__footer {
    flex: 0 0 100%;
    width: 100%;
    @include more(scale) {
      margin-top: 140px;
    }
    @include mq(scale) {
      margin-top: 35rem;
    }
  }

  .quiz-final__count {
    margin-bottom: 16px;
  }

  .quiz-final__bullets {
    margin-bottom: 16px;
  }

  .quiz-final__likes {
    margin-top: 20px;
  }

  .quiz-final__restart {
    @include more(scale) {
      animation: 0.5s opacity, 0.5s transform;
      margin-top: 30px;
    }
    @include less(tablet) {
      margin-top: 40px;
    }
    @include screen-height(mobile-low) {
      margin-top: 24px;
    }
  }

  .quiz-final__form-text {
    @include less(tablet) {
      margin-bottom: 15px;
    }
  }

  .quiz-final__main {
    transition: 1s opacity, 1s transform;
    @include mq(scale) {
      padding-right: 120px;
    }
    @include mq(tablet) {
      max-width: 480px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 100px;
    }
    @include mq(mobile) {
      margin-bottom: 80px;
    }
    @media screen and (max-width: 400px) and (max-height: 640px) {
      margin-bottom: 40px;
    }
  }

  .quiz-final__aside {
    transition: 1s opacity, 1s transform;
    @include more(scale) {
      max-width: 540px;
    }

    @include less(tablet) {
      margin-left: -30px;
      margin-right: -30px;
      padding: 30px;
      background: $background;
      padding-bottom: 100px;
    }
  }

  .quiz-final__form-text-content {
  }

  .quiz-enter-active {
    .quiz-final__header {
      opacity: 0;
      transform: translateY(-100%)
    }
    .quiz-final__header .header__special-label {
      opacity: 0;
      transform: translateY(20px)
    }
    .quiz-final__main {
      opacity: 0;
      transform: translateY(50px);
    }
    .quiz-final__aside {
      opacity: 0;
      transform: translateY(50px);
    }
  }
  .quiz-enter-to {
    .quiz-final__header {
      opacity: 1;
      transform: translateY(0)
    }
    .quiz-final__header .header__special-label {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.25s;
    }
    .quiz-final__main {
      opacity: 1;
      transform: translateY(0);
    }
    .quiz-final__aside {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.15s;
    }
  }
  .quiz-leave-active {
    .quiz-final__header {
      opacity: 0;
      transform: translateY(-100%);
      transition-delay: 0.25s;
    }
    .quiz-final__header .header__special-label {
      opacity: 0;
      transform: translateY(-20px)
    }
    .quiz-final__main {
      opacity: 0;
      transform: translateY(50px);
      transition-delay: 0.1s;
    }
    .quiz-final__aside {
      opacity: 0;
      transform: translateY(50px);
      transition-delay: 0.25s;
    }
  }
</style>
